import React from "react";
import { CTAButton } from "./UI";

const CONTENT_TYPES = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3.5" y="3.5" width="17" height="17" rx="5" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.4"/>
        <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor"/>
      </svg>
    ),
    title: "Social Media Content",
    body: "Reels, posts and stories built for your brand and your audience.",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M10 9.5l5 2.5-5 2.5V9.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Ad Creatives",
    body: "Scroll-stopping visuals and copy designed to perform in paid campaigns.",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="10" r="4" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M5 20c0-3.31 3.13-6 7-6s7 2.69 7 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M17 4l2 2-2 2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Campaign Shoots",
    body: "Professional photography and video production for your brand and products.",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M15 10l4.553-2.277A1 1 0 0 1 21 8.618v6.764a1 1 0 0 1-1.447.894L15 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="3" y="7" width="12" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      </svg>
    ),
    title: "Brand Films",
    body: "Short-form brand stories that communicate who you are and why it matters.",
  },
];

export default function ContentSection() {
  return (
    <section id="content" className="section content-dark">
      <div className="container">

        <div className="ct-head">
          <span className="eyebrow" style={{ color: "var(--gold)" }}>Content · Creative</span>
          <h2 className="ct-heading">Content that makes people stop, watch and remember.</h2>
          <p className="ct-sub">
            In a world where everyone is fighting for attention, your content is your edge. We produce creative that gets noticed — and gets results.
          </p>
        </div>

        <div className="ct-grid">
          {CONTENT_TYPES.map((c, i) => (
            <div className="ct-card" key={c.title}>
              <span className="ct-card-icon">{c.icon}</span>
              <span className="ct-card-num">0{i + 1}</span>
              <h3 className="ct-card-title">{c.title}</h3>
              <p className="ct-card-body">{c.body}</p>
            </div>
          ))}
        </div>

        <div className="ct-bottom">
          <p className="ct-statement">
            "Good content isn't about going viral. It's about being remembered by the right people."
          </p>
          <CTAButton href="#contact">Start creating</CTAButton>
        </div>

      </div>
    </section>
  );
}
